import React from 'react';
import { Box } from '@mui/material';

const PageContainer = ({ children, sx = {}, ...props }) => {
  return (
    <Box
      sx={{
        maxWidth: '100%',
        mx: 'auto',
        px: { xs: 1, sm: 2, md:0 },
        width: '100%',
        ...sx
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default PageContainer; 